export default __webpack_public_path__ + "c15e3cdaa037aa2d612029975f717f4a.woff";